import React from 'react'
import styled from 'styled-components'
const Styles = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    .text-field{
        width: calc(100% - 2rem);
        padding: var(--fs-textfield) calc(1rem - 1px);
        border-radius: var(--border-radius);
        border: 1px var(--border-2) solid;
        outline: none;
        transition: var(--trans-1);
        font-size: var(--fs-textfield);
        &.error-text{
            border: 1px var(--secondry-1) solid;
        }
        &.ltr-text {
            direction: ltr;
            text-align: left;
        }
        :focus {
            border: 1px var(--border-3) solid;
        }
    }
    .error {
        display: flex;
        height: 1rem;
        font-size: var(--fs-small);
        .icon {
            text-align: center;
            width: 1rem;
            height: 1rem;
        }
        .text {
            margin: 0 0.2rem 0 0;
        }
    }
    @media screen and (max-width: 1445px){
        .text-field {
            padding: 0.7rem 1rem;
        }
    }
`

    // dokme chesm baray ramz ha

export const FileInput = ({style, name, error, value, onchange, placeHolder, required, ltr}) => {
    let errorComp = '';
    let classes = 'text-field';
    if(error.toString()){
        classes = 'text-field error-text';
        errorComp = (
            <React.Fragment>
                <div className='icon'>
                    !
                </div>
                <div className='text'>
                    {error}
                </div>
            </React.Fragment>
        )
    }
    if(ltr) {
        classes+= ' ltr-text';
    }
    return (
        <Styles style={style}>
            <input className={classes} name={name} type='file' onChange={onchange} required={required}/>
            <div className='error'>
            {errorComp}
            </div>
        </Styles>
    )
}